import { create } from 'zustand'

import { PostModel } from '@/common/models/post'

interface EditNewsStore {
  news: PostModel | null
  setNews: (news: PostModel | null) => void
}

export const useEditNewsStore = create<EditNewsStore>((set) => ({
  news: null,
  setNews: (news) => set({ news }),
}))
